
import { FETCH_REGTYPES, CREATE_REGTYPE, UPDATE_REGTYPE, DELETE_REGTYPE, UPDATE_DEFAULT_REGTYPE } from '../actions';
import { NotificationManager } from 'react-notifications';
const initialState = {
  selectedToDelete: null,
  selectedToEdit: null,
  setRegType: null,
  updateRegType: null,
  updateDefaultType: null,
  regTypes: [],
  loading: false,
  updateRegTypeError:null,
  updateDefaultTypeError:null,
  setRegTypeError:null,
  regTypesError:null,
  selectedToDeleteError:null,
};

function regTypeReducer(state = initialState, action) {
  let selectedToDelete,
    selectedToEdit,
    regTypes,
    setRegType,
    updateRegType,
    updateDefaultType;
  switch (action.type) {
    case `${UPDATE_DEFAULT_REGTYPE}_PENDING`:
    case `${UPDATE_REGTYPE}_PENDING`:
    case `${CREATE_REGTYPE}_PENDING`:
    case `${FETCH_REGTYPES}_PENDING`:
    case `${DELETE_REGTYPE}_PENDING`:
      return { ...state, loading: true,
        updateRegTypeError:null,
        updateDefaultTypeError:null,
        setRegTypeError:null,
        regTypesError:null,
        selectedToDeleteError:null
      };

    case `${UPDATE_REGTYPE}_FULFILLED`:
      updateRegType = action.payload.data;
      return { ...state, loading: false, updateRegType };

    case `${UPDATE_DEFAULT_REGTYPE}_FULFILLED`:
      updateDefaultType = action.payload.data;
      return { ...state, loading: false, updateDefaultType };

    case `${CREATE_REGTYPE}_FULFILLED`:
      setRegType = action.payload.data;
      return { ...state, loading: false, setRegType };

    case `${FETCH_REGTYPES}_FULFILLED`:
      regTypes = action.payload.data;
      return { ...state, loading: false, regTypes };

    case `${DELETE_REGTYPE}_FULFILLED`:
      selectedToDelete = action.payload.data;
      return { ...state, loading: false, selectedToDelete };

    case `${UPDATE_DEFAULT_REGTYPE}_REJECTED`:
      return {...state, loading: false, updateDefaultTypeError: action.payload.response.data, state: initialState };
    case `${UPDATE_REGTYPE}_REJECTED`:
      return {...state, loading: false, updateRegTypeError: action.payload.response.data, state: initialState };
    case `${CREATE_REGTYPE}_REJECTED`:
      return {...state, loading: false, setRegTypeError: action.payload.response.data, state: initialState };
    case `${FETCH_REGTYPES}_REJECTED`:
      return {...state, loading: false, regTypesError: action.payload.response.data, state: initialState };
    case `${DELETE_REGTYPE}_REJECTED`:
      return {...state, loading: false, selectedToDeleteError: action.payload.response.data, state: initialState };

    default:
      return state;
  }
}

export default regTypeReducer;
